import * as hex from "./grid_hex";
import * as square from "./grid_square";

// The scene's grid bound to its math: every point is in image pixels.
export function gridMath(grid) {
	const math = grid.kind === "hex" ? hex : square;
	return {
		grid,
		centerOf: (col, row) => math.centerOf(grid, col, row),
		cellAt: (x, y) => math.cellAt(grid, x, y),
		cellPolygon: (col, row) => math.cellPolygon(grid, col, row),
		visibleCells: (rect) => math.visibleCells(grid, rect),
		distance: (from, to) => math.distance(grid, from, to),
	};
}

// The image a grid of cols × rows cells fills from the image's origin; the
// Ruby twin is MapGrid#extent. An odd-parity hex grid's odd columns reach half
// a row lower than its rows.
export function extent(grid, cols, rows) {
	if (grid.kind !== "hex") return { width: grid.offset_x + cols * grid.cell_w, height: grid.offset_y + rows * grid.cell_h };
	const lower = grid.hex_parity === "odd" ? 0.5 : 0;
	return { width: grid.offset_x + grid.cell_w * (0.75 * cols + 0.25), height: grid.offset_y + grid.cell_h * (rows + lower) };
}

// The server's MapScene::MAX_SIDE_PX: a scene wider or taller than this is refused.
export const MAX_SIDE_PX = 20_000;

// A blank scene's size in whole pixels, as the server sizes it.
export function sceneSize(grid, { cols, rows }) {
	const { width, height } = extent(grid, cols, rows);
	return { width_px: Math.ceil(width), height_px: Math.ceil(height) };
}

// The cell counts a scene of this size holds, the inverse of extent.
export function cellCounts(grid, width, height) {
	const across = (width - grid.offset_x) / grid.cell_w;
	const down = (height - grid.offset_y) / grid.cell_h;
	const hex = grid.kind === "hex";
	const cols = hex ? (across - 0.25) / 0.75 : across;
	const rows = hex && grid.hex_parity === "odd" ? down - 0.5 : down;
	return { cols: Math.max(1, Math.round(cols)), rows: Math.max(1, Math.round(rows)) };
}
